var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 48 48.00004"
    },
    viewBox: "0 0 48 48.00004",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Padding__x26__Artboard"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.28027,14.23923v-2.10382c0-0.41016-0.20996-0.78906-0.57031-1.01953   c-0.35693-0.21484-0.80371-0.23633-1.22803-0.01367l-3.98389,3.18262c-0.40625,0.21094-0.65869,0.62109-0.65869,1.07129   c0,0.45605,0.26172,0.87793,0.60156,1.0332l4.10107,3.25879c0.16504,0.08301,0.35107,0.12695,0.53809,0.12695   c0.22949,0,0.4502-0.06348,0.62939-0.17871c0.35205-0.21094,0.5708-0.60156,0.5708-1.02051v-1.81042   c3.53613,1.34058,5.96973,4.82129,5.96973,8.6405c0,5.10059-4.14941,9.25-9.25,9.25s-9.25-4.14941-9.25-9.25   c0-2.3623,0.89746-4.61328,2.52783-6.33887c0.18652-0.19727,0.28271-0.46289,0.26514-0.72754   c-0.01709-0.26074-0.13867-0.49414-0.34131-0.6582l-0.40039-0.3252c-0.3833-0.31152-0.94385-0.2793-1.27686,0.0752   c-2.04688,2.16992-3.17432,5.00195-3.17432,7.97461c0,6.42383,5.22608,11.64941,11.6499,11.64941s11.6499-5.22559,11.6499-11.64941   C35.6499,20.23563,32.22009,15.68674,27.28027,14.23923z",
    style: {
      fill: "#303030"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.d6fe0e192d4d7ba6d4dd12789fea25fe.svg";
export { ForwardRef as ReactComponent };